type Props = {
  className?: string;
};
export function SearchIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.32812 0.957031C9.64183 0.957031 12.3281 3.64332 12.3281 6.95703C12.3281 8.35895 11.8448 9.64655 11.0391 10.668L16 15.6289L14.5859 17.0439L9.55566 12.0127C8.62345 12.6091 7.51688 12.957 6.32812 12.957C3.01442 12.957 0.328125 10.2707 0.328125 6.95703C0.328125 3.64332 3.01442 0.957031 6.32812 0.957031ZM6.32812 2.95703C4.11899 2.95703 2.32812 4.74789 2.32812 6.95703C2.32812 9.16617 4.11899 10.957 6.32812 10.957C8.53726 10.957 10.3281 9.16617 10.3281 6.95703C10.3281 4.74789 8.53726 2.95703 6.32812 2.95703Z"
        fill="currentColor"
      />
    </svg>
  );
}
